
import useAcordos from "core/features/acordo/hooks/useAcordos";
import AccordionTable from "ui/components/AccordionTable";
import {  UseAcordosProps } from "core/features/acordo/typings";
import { useAccordionColumns, useAccordionInnerColumns } from '../../hooks/useAccordionColumns'





interface HistoricoDeAcordoProps {
    unidadeId: string | undefined
}

function HistoricoDeAcordo({ unidadeId }: HistoricoDeAcordoProps) {


    const columnsAccordion = useAccordionColumns()
    const columnsInnerAccordion = useAccordionInnerColumns()

    const unidadeIdParam: UseAcordosProps = {
        page: 1,
        limit: 10,
        unidadeId: unidadeId
    }

    const { data, isLoading } = useAcordos(unidadeIdParam)

    return (
        <>
            <AccordionTable
                loading={isLoading}
                columnsAccordion={columnsAccordion}
                columnsInnerTable={columnsInnerAccordion}
                dataAccordion={data?.items ?? []}
            />
        </>);
}

export default HistoricoDeAcordo